import SitemapComponent from 'components/SitemapComponent'
import MetaTags from 'components/MetaTags'
import { defaultMeta } from 'shared/constants'

const Sitemap = () => {
  return (
    <>
      <MetaTags data={defaultMeta} />
      <SitemapComponent />
    </>
  )
}

export default Sitemap
